"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.parse = parse;
const planFunction_1 = require("../../../model/v1/planFunction");
const planVariableTypes_1 = __importDefault(require("../../../model/v1/planVariableTypes"));
function parse(planFunctions) {
    const out = [];
    planFunctions.forEach(p => {
        const req = {
            id: p.id,
            created: new Date(p.created),
            branchId: p.branchID,
            variableName: p.variableName,
            type: planVariableTypes_1.default.FUNC,
        };
        const opt = {
            functionBody: p.defaultFunctionBody,
            allowDefaultFunction: p.allowDefaultFunction,
            showInSummaryPage: p.showInSummary,
            isDeleted: p.isDeleted,
        };
        const plan = new planFunction_1.PlanFunction(req, opt);
        out.push(plan);
    });
    return out;
}
